import { useState, useEffect, useContext, createRef, useRef } from "react";
import { useCurrentCompany } from "../../../hooks";
import { useTranslation } from "react-i18next";
import { useUser} from "../../../hooks/userInfoHooks/useUser";
import { useApplication } from "../../../hooks/templateHooks/useApplication";
import { DOMAINNAME, HTTPS, HTTP, ServeRoute,AUTH_VALIDATE,AUTH_PROXY_URL } from "../../../Constants";
import { useParameter } from "../../../hooks/templateHooks/useParameter";
import { EncryptKeyToken } from "../../../helpers/CookieToken";
import { useNavigate } from "react-router-dom";
import CustomLottie from "../../../components/templateComponents/CustomLottie";
import { useSpinLoadStore } from "../../../store/useSpinLoadStore";

export const ApplicationSelector = () => {
  const { ShowLoad, HideLoad } = useSpinLoadStore();
  const { Company, setCurrentSelectedCompany } = useCurrentCompany();
  const [CompanyUserList, setCompanyUserList ] = useState([]);
  const [AppList, setAppList] = useState([]);
  const { User,GetCompanyByUser,GetApplicationByUser } = useUser();
  const AppHook = useApplication();
  const ParameterHook = useParameter();
  const [t] = useTranslation("global");
  const navigate = useNavigate();

  const lottieRef = useRef([]);

  const HandleLottieRefPlay = (i) => {
    
    if(lottieRef) lottieRef?.current[i]?.setPlay();
  };

  const HandleLottieRefStop = (i) => {
    if(lottieRef) lottieRef?.current[i]?.stopAnimation();
  };

  useEffect(() => {
    (async () => {
      ShowLoad();
      if (Company.idCompany === 0) {
        let rslt = await GetCompanyByUser(User.idUser);
        if (!rslt.errorMessage) {
          setCompanyUserList(rslt);
        } else {
          navigate(`${ServeRoute}/ErrorServer`);
        }
      } else {
        await GetAppsByCompanySelected(Company.idCompany);
      }
      HideLoad();
    })();
  }, []);

  const GetAppsByCompanySelected = async (idCompany) => {
    ShowLoad();
    let IC = "";
    //Obtenemos los parmetros cargados  de la aplicacion
    let CompanyKeys = ParameterHook.GetParameterLoaded();
    //Obtenemos el IC de los Parametros
    CompanyKeys.filter((x) => x.code.includes("CONFIG_CSS")).forEach((x) => {
      let objCompany = JSON.parse(x.value);
      if (objCompany.IdCompany === idCompany) {
        IC = objCompany.IcKey;
      }
    });
    //Obtenemos el PIGNUS de usuario logeado para enviarlo en la URL
    let PignusKey = User.idUser.toString().padStart(6, "0");
    let PIGNUS = await EncryptKeyToken(PignusKey);
    /////////////////////////////
    let rslt = await GetApplicationByUser(User.idUser);
    if (!rslt.errorMessage) {
      let map = await Promise.all(
        rslt.map(async (x) => {
          let rslt = await AppHook.GetCompanyByApplication(x.idApplication);
          return {
            ...x,
            ...{ icKey: IC, pignus: PIGNUS },
            ...{
              company:
                rslt.length > 0
                  ? rslt.filter((item) => item.idCompany === idCompany)[0]
                    ? rslt.filter((item) => item.idCompany === idCompany)[0]
                    : { idCompany: null }
                  : { idCompany: null },
            },
          };
        })
      );
      setAppList([
        ...map.filter(
          (x) =>
            x.company.idCompany === idCompany &&
            x.applicationType.applicationTypeName === "Web"
        ),
      ]);
    } else {
      navigate(`${ServeRoute}/ErrorServer`);
    }
    //Mapeamos los datos y buscamos las aplicaciones de la copañia seleccionada
    HideLoad();
  };

  const BuildURLApp = (App) => {
    let URLoutput = "";
    let APPURL = `${
      App.pathWeb.includes(HTTPS)
                      ? App.pathWeb.replace(`${DOMAINNAME}`, window.location.host)
                      : App.pathWeb.replace(
                          `${HTTP}://${DOMAINNAME}`,
                          window.location.origin
                        )
                  }?ic=${App.icKey}&PIGNUS=${App.pignus}`
    if(JSON.parse(AUTH_VALIDATE)){
      URLoutput = `${AUTH_PROXY_URL}?IdUser=${User.idUser}&IdApplication=${App.idApplication}&Redirect=${APPURL}`
    }else {
      URLoutput = APPURL;
    }

    return URLoutput; 
  }
  

  return (
    <div className=" w-full pb-10 bg-test">
      <div className="flex-row gap-y-5 px-8">
        {Company.idCompany === 0 && (
          <>
            <div className="rounded-md border-double border-skin-primary border-4 flex justify-center items-center bg-skin-primary/20 text-base mt-4 md:text-xl font-bold py-2 h-fit mb-3">
              {t("Login.SelectCompany")}
            </div>
            <div className="grid grid-flow-row grid-rows-1 md:grid-flow-col md:grid-rows-3 lg:grid-rows-2 xl:grid-rows-1 gap-2 bg-slate-300 justify-between px-4 py-2 md:px-16 items-center rounded-md border">
              {CompanyUserList.filter((x) => x.idCompany !== 0).map(
                (x, indx) => (
                  <label key={indx}>
                    <input
                      type="radio"
                      name="IdCompanySelected"
                      onChange={() => {
                        setCurrentSelectedCompany(x)
                        GetAppsByCompanySelected(x.idCompany);
                      }}
                      value={`${x.idCompany}`}
                    />
                    <span className={`mx-2 font-semibold`}>
                      {x.companyName}
                    </span>
                  </label>
                )
              )}
            </div>
          </>
        )}
      </div>
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 justify-center items-center gap-y-8 gap-x-4 mx-24">
        {AppList.length > 0 &&
          AppList.map((x, indx) => {
            return (
              <div key={indx}>
                <a
                  className="group"
                  key={indx}
                  href={BuildURLApp(x)}
                  // onGotPointerCapture={}
                  onMouseEnter={() => HandleLottieRefPlay(indx)}
                  onMouseLeave={() => HandleLottieRefStop(indx)}
                >
                  <div className="bg-mainBG bg-cover bg-center border-1 border-skin-primary/40 rounded-[1.5rem] h-[100%] rounded-tr-[40%] flex-row px-2 py-3 transition-all duration-300 ease-in-out z-0  group-hover:shadow-card relative overflow-hidden ">
                    <div className=" flex place-content-center">
                      {/*
                        className="bg-white/0 bg-cover bg-center rounded-xl border-1 border-black/0 p-2 w-[70%]  transition-all duration-500 ease-in-out origin-center h-fit

                       group-hover:scale-0  group-hover:rotate-y-360 "
                      */}
                    
                        <img
                          className="drop-shadow-card p-4 transition-all duration-500 ease-in-out origin-center group-hover:scale-0  group-hover:rotate-y-360"
                          src={x.company.logo}
                          alt=""
                        />
                      
                    </div>
                    <div className="">
                      {console.log(x.company)}
                      {x.company.logoAnimate ? (
                        <>
                          <CustomLottie
                            className="w-[70%] scale-0 opacity-100 group-hover:scale-100 group-hover:opacity-100  transition-all duration-300 ease-in-out absolute top-[4.5rem] left-[2.5rem]"
                            animationData={x.company.logoAnimate}
                            segmentsToPlay={120}
                            ref={(ref) => (lottieRef.current[indx] = ref)}
                          />
                        </>
                      ) : (
                      <>
                        <img
                          className=" drop-shadow-card w-[70%] scale-0 opacity-100 group-hover:scale-100 group-hover:opacity-100  transition-all duration-300 ease-in-out absolute top-[4.5rem] left-[2.5rem]"
                          src={x.company.logo}
                          alt=""
                        />
                      </> 
                      )}

                        {/*
                          <span className="flex mb-8 mt-2 justify-center items-end  text-2xl font-semibold text-skin-primary text-wrap mx-4 translate-x-[200%] group-hover:translate-x-0 transition-all duration-300 ease-in-out h-fit drop-shadow-card">
                        */}
                        </div>
                     
                    <div className="h-[5rem] justify-center flex text-2xl font-bold text-skin-primary "> {x.applicationName}</div>
                  </div>
                  <div className="text-right text-xs mr-4 mt-1 italic font-semibold">
                    version 1.0.0.b
                  </div>
                </a>
              </div>
            );
          })}
      </div>
      {AppList <= 0 && (
        <>
          <div className="grid card mx-8 gap-4 py-8 bg-skin-primary/20 border-4 border-double border-skin-primary">
            <i className="i-warning text-9xl place-self-center"></i>
            <label className="font-semibold place-self-center text-4xl">
              {t("Login.PleaseSelectCompany")}
            </label>
          </div>
        </>
      )}
    </div>
  );
};
